import api from '@/api';
import AuthLayout from '@/views/Layout/AuthLayout.vue';
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import NotFound from '@/views/GeneralViews/404.vue';

// Pages
import Dashboard from '../views/Dashboard';
import Organisations from '../views/Organisations';
import Organisation from '../views/Organisation';
import Farms from '../views/Farms';
import Farm from '../views/Farm';
import Groups from '../views/Groups';
import Group from '../views/Group';
import Sensors from '../views/Sensors';
import Sensor from '../views/Sensor';
import Users from '../views/Users';
import User from '../views/User';
import SystemStatus from '../views/SystemStatus';
import SystemSettings from '../views/SystemSettings';
import Login from '../views/Pages/Login';
import ResetPassword from '../views/Pages/ResetPassword';
import SendResetCode from '../views/Pages/SendResetCode';
import CreateRole from '../views/CreateRole';
import EditRole from '../views/EditRole';
import Roles from '../views/Roles';
import Reports from '../views/Reports';
import Report from '../views/Report';

const pass = async (state, to, from, next) => {
  const online = await api.auth.checkUserSessionIsValid();

  if (state === 'online') {
    return online ? next() : next('/login');
  } else if (state === 'offline') {
    return !online ? next() : next('/');
  }
};

export default [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'organisations',
        name: 'Organisations',
        component: Organisations,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'farms',
        name: 'Farms',
        component: Farms,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'groups',
        name: 'Orchards',
        component: Groups,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'sensors',
        name: 'Traps',
        component: Sensors,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'users',
        name: 'Users',
        component: Users,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'access/roles/create',
        name: 'createRole',
        component: CreateRole,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'access/roles/:id',
        name: 'editRole',
        component: EditRole,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'users/:id',
        name: 'user',
        component: User,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'farms/:id',
        name: 'farm',
        component: Farm,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'groups/:id',
        name: 'group',
        component: Group,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'organisations/:id',
        name: 'organisation',
        component: Organisation,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'sensors/:id',
        name: 'sensor',
        component: Sensor,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'system/status',
        name: 'Status',
        component: SystemStatus,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'system/settings',
        name: 'Settings',
        component: SystemSettings,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'access/roles',
        name: 'Roles',
        component: Roles,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'reports',
        name: 'Reports',
        component: Reports,
        beforeEnter: pass.bind(null, 'online')
      },
      {
        path: 'reports/:id',
        name: 'report',
        component: Report,
        beforeEnter: pass.bind(null, 'online')
      },
    ]
  },
  {
    path: '/',
    component: AuthLayout,
    name: 'Authentication',
    children: [
      {
        path: '/login',
        name: 'Login',
        props: true,
        component: Login,
        beforeEnter: pass.bind(null, 'offline')
      },
      {
        path: '/resetPassword',
        name: 'ResetPassword',
        props: true,
        component: ResetPassword,
        beforeEnter: pass.bind(null, 'offline')
      },
      {
        path: '/sendResetCode',
        name: 'SendResetCode',
        props: true,
        component: SendResetCode,
        beforeEnter: pass.bind(null, 'offline')
      },
      { path: '*', component: NotFound }
    ]
  }
];
